import React from 'react';

export const TransactionsPage: React.FC = () => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontSize: '24px',
      color: '#666'
    }}>
      <div>
        <h2>Giao dịch (Desktop)</h2>
        <p>Phiên bản desktop đang được phát triển</p>
        <p>Vui lòng sử dụng phiên bản mobile để xem giao dịch</p>
      </div>
    </div>
  );
};
